import { MultiSelect } from 'primereact/multiselect';
import { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectedReportsFilter, setReportsFilter } from '../../redux/reducers/filterReportsSlice';
import { Grade } from '../../models/Grade';
import { selectedCsvProcess } from '../../redux/reducers/csvProcessSlice';
import { useLazyLoadQuery } from 'react-relay';
import { ClassesAllGradesQuery } from '../../graphQLOperations/__generated__/ClassesAllGradesQuery.graphql';
import { allGrades } from '../../graphQLOperations/Classes';
import { MonitoringStandardsGradesQuery } from '../../graphQLOperations/__generated__/MonitoringStandardsGradesQuery.graphql';
import { allStandardsGrades } from '../../graphQLOperations/Monitoring';

const MonitoringSubFilters: FC = () => {
  const dispatch = useAppDispatch();
  const reportsFilterRedux = useAppSelector(selectedReportsFilter);
  const isCsvProcessing = useAppSelector(selectedCsvProcess);
  const standardsGradesData = useLazyLoadQuery<MonitoringStandardsGradesQuery>(allStandardsGrades, {});
  const standardGradesTemplate = standardsGradesData.standardGrades.map(el => ({ name: el.name, code: el.id }));
  const gradesLevelsData = useLazyLoadQuery<ClassesAllGradesQuery>(allGrades, {});
  const gradesLevelTemplate = gradesLevelsData?.allGradeLevels?.map(element => element);

  return (
    <div className="grid nc_filters align-items-center">
      <div className="field col-12 lg:col-2">
        <h4>Filters:</h4>
      </div>
      <div className="field col-12 lg:col-3">
        <label htmlFor="grade">Student Grade</label>
        <MultiSelect
          onChange={e => dispatch(setReportsFilter({ ...reportsFilterRedux, grades: e.value }))}
          value={reportsFilterRedux?.grades}
          options={(gradesLevelTemplate as Grade[])?.sort((a, b) => {
            return a.order - b.order;
          })}
          optionLabel="name"
          display="chip"
          id="site"
          className="w-full"
          filter
          disabled={isCsvProcessing}
        />
      </div>
      <div className="field col-12 lg:col-3">
        <label htmlFor="skillGrade">Skill Grade</label>
        <MultiSelect
          onChange={e => dispatch(setReportsFilter({ ...reportsFilterRedux, skillGrades: e.value }))}
          value={reportsFilterRedux?.skillGrades}
          options={standardGradesTemplate.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))}
          optionLabel="name"
          display="chip"
          id="site"
          className="w-full"
          filter
          disabled={isCsvProcessing}
        />
      </div>
      <div className="col-12">
        <small>* required</small>
      </div>
    </div>
  );
};

export default MonitoringSubFilters;
